import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "eye-a11y--sprite",
  "use": "eye-a11y--sprite-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"eye-a11y--sprite\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12 18.5A9.505 9.505 0 012.985 12a9.505 9.505 0 0118.034 0A9.505 9.505 0 0112 18.5zM12 4c5.036 0 9.28 3.383 10.587 8-1.306 4.617-5.551 8-10.586 8s-9.28-3.383-10.586-8C2.72 7.383 6.965 4 12 4zm-2.25 8a2.25 2.25 0 114.5 0 2.25 2.25 0 01-4.5 0zM12 8.25a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol